import { Component, OnInit } from '@angular/core';
import { ResponseGroupService } from 'src/app/services/response_group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

@Component({
    selector: 'app-questionnaire-review',
    templateUrl: './questionnaire-review.component.html',
    styleUrls: ['./questionnaire-review.component.scss'],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle]
})
export class QuestionnaireReviewComponent implements OnInit {

  customerResponse: any;
  userId: string = '';
  error: boolean = false;
  errorMessage: string = '';

  constructor(
    private responseService: ResponseGroupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      const id = params.get('id');

      if(id != null) {
        this.userId = id.toString();
        this.getCustomerQuestionnaire(this.userId);
      }
      else {
        this.router.navigate(['customers']);
      }
    });
  }

  getCustomerQuestionnaire(customerGuid: string): void {
    this.responseService.getLatestUserResponse(['GetLatestByUserId/' + customerGuid],new Map()).subscribe(x => {

      if(x.error) {
        this.error = x.error;
        this.errorMessage = x.message;
      }
      else {
        this.customerResponse = x;

        this.customerResponse.forEach((k: any) => {
          this.formatDates(k.questionAnswers);
        })
      }
    })
  }

  formatDates(questions: any[]) {
    questions.forEach((k: any) => {
      const answer = k?.answers?.[0];

      if (
        answer &&
        answer.question &&
        answer.question.type === 'date' &&
        answer.value
      ) {
        const date = new Date(answer.value);
        answer.value = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
      }
    });
  }
}
